/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { ListTable } from "@insticator/insticator-ui";
import CardWrapper from "../cardwrapper/cardwrapper";
// styles
import injectSheet from 'react-jss';
import styles from './tablereportsection_styles';
import LoadingState from '../states/loading/loading';
import NoDataState from '../states/nodata/nodata';


/* ========== ~~~~~~~~~~ TABLE REPORT SECTION ~~~~~~~~~~ ========== */
const TableReportSection = injectSheet(styles)((props) => {
    const {
        title,
        columns,
        data,
        rowsPerPage,
        clickableColumns,
        exportData,
        exportAll,
        tooltipContent,
        loading,
        type
    } = props;

    // copying noData logic from insticator-ui
    const noData = !data.length;
    return (
        <CardWrapper klass={`tablereportsection ${props.classes.tablereportsection}`} loading={false} tooltipContent={tooltipContent}>
            {loading && <LoadingState />}
            {!loading && noData && <NoDataState title={title}/>}
            {!loading && !noData &&
                <div className={`tablereport`}>
                    <div className={`title`}>{title}</div>
                    <ListTable className={`table`}
                        columnHeads={columns}
                        data={data}
                        variant={'standard'}
                        type={type || 'nowrap'}
                        rowsPerPage={rowsPerPage}
                        paginationLocation={'bottom'}
                        exportLocation={'footer'}
                        clickableColumns={clickableColumns}
                        exportData={exportData}
                        exportAll={exportAll}>
                    </ListTable>
                </div>
            }

        </CardWrapper>

    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default TableReportSection;
